import { ReactNode } from 'react';
import { useUserFeatureValue } from '../hooks';

type UserFeatureFlagProps = {
  feature: string;
  defaultValue?: boolean;
  children: ReactNode;
  alternative?: ReactNode;
};

export const UserFeatureFlagged = ({
  feature,
  defaultValue,
  children,
  alternative = <></>,
}: UserFeatureFlagProps) => {
  const userFeatureValue = useUserFeatureValue({ feature, defaultValue });
  return userFeatureValue ? <>{children}</> : <>{alternative}</>;
};
